export const STORAGE_KEY_CAS_NUMBER = 'casNumber';
export const REDUCER_KEY_CAS_NUMBER = 'casNumber';

export const FETCH_CAS_NUMBER = 'casNumber/FETCH_CAS_NUMBER';
export const FETCH_CAS_NUMBER_SUCCESS = 'casNumber/FETCH_CAS_NUMBER_SUCCESS';
export const FETCH_CAS_NUMBER_FAILURE = 'casNumber/FETCH_CAS_NUMBER_FAILURE';
export const ADD_CAS_NUMBER_FOR_RESULT_NAME = 'casNumber/ADD_CAS_NUMBER_FOR_RESULT_NAME';
export const CLEAR_CAS_NUMBERS = 'casNumber/CLEAR_CAS_NUMBERS';

export class ErrorNumbers {
  static CAS_RN_UNAVAILABLE = 32;

  static CAS_API_UNAVAILABLE = 33;

  static CAS_RN_UNAVAILABLE_ZERO_RESULTS = 36;

  static CAS_RN_UNAVAILABLE_MULTIPLE_RESULTS = 37;

  static CAS_RN_UNAVAILABLE_INCHI_NOT_MATCHED = 38;

  static UNKNOWN_EXCEPTION = -1;
}

export const SUPPORT_HUB_LINK = 'https://service.elsevier.com/app/answers/detail/a_id/34891/supporthub/reaxys/';
